import MaritalStatus, { type MaritalStatusFieldProps } from '../../../components/fields/MaritalStatusField';
import SelectField from './SelectField';

const MaritalStatusField = (props: MaritalStatusFieldProps) => <MaritalStatus SelectComp={SelectField} {...props} />;

export default MaritalStatusField;
